import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux";
import { Typography, Slider, IconButton, Box, Grid, useTheme } from '@mui/material';
import { AddCircle, RemoveCircle, HelpRounded } from '@mui/icons-material';
import Parser from 'html-react-parser';
import { useForm, FormProvider } from "react-hook-form";

import { GenericContainer, InputField, GenericDialog, Alert, CustomLoadingOverlay, Buttons } from '../../components'
import { useStyles } from "./CreditQuoteStyles";
import { coreFunctions } from '../../utils'
//import { mainStyles, theme } from "../../styles/Main.js";
import { fileActions, creditActions } from "../../store/actions";
import { removeNullCharacters } from "pdfjs-dist";
import { useTranslation } from "react-i18next";

const formatterDolar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
})

export default function CalculatorComponent(props) {
  const theme = useTheme()
  const formMethods = useForm({ mode: "onChange" });
  const { control, handleSubmit, register, formState, watch, setValue } = useForm({ mode: "onBlur" });

  const watchMonto = watch("txtMonto")
  const localStyles = useStyles();
  const gridContainer = {} //mainStyles.gridStyle();
  const navigate = useNavigate();
  const location = useLocation()
  const classes = {} //mainStyles.bodyStyles();

  const [montoCurrent, setMontoCurrent] = useState(1000);
  const [fileId, setFileId] = useState(0)
  const [activeInitial, setActiveInitial] = useState(false)
  // const [calculatorOptions, setCalculatorOptions] = useState([])
  const [activeFileInfo, setActiveFileInfo] = useState(false)

  const [itemMonth, setItemMonth] = useState({})
  const [maxSlider, setMaxSlider] = useState(203000)
  const [maxAmount, setMaxAmount] = useState('')

  const [plazo, setPlazo] = useState('')
  const [tasaAnual, setTasaAnual] = useState('')
  const [tasaAnualIva, setTasaAnualIva] = useState('')
  const [tasaMensual, setTasaMensual] = useState('')
  const [tasaMensualIva, setTasaMensualIva] = useState('')
  const [cat, setCat] = useState('')
  const [pagoMensual, setPagoMensual] = useState('')
  const [loadView, setLoadView] = useState(false);

  const [title, setTitle] = useState("");
  const [open, setOpen] = useState(false);

  const [stageProps, setStageProps] = useState(0)
  const [capacidadPago, setCapacidadPago] = useState('')
  const [activeButton, setActiveButton] = useState(false)

  const [optionsPlazos, setOptionsPlazos] = useState([])
  const [namePlazo, setNamePlazo] = useState("meses")
  const [plazoCurrent, setPlazoCurrent] = useState("")
  const [minSlider, setMinSlider] = useState(1000)
  const [saltoSlaider, setSaltoSlaider] = useState(1000)
  const [namePlazoCalculate, setNamePlazoCalculate] = useState("mensual")

  //Redux hooks
  const auth = useSelector((state) => state.Authentication);
  const wf = useSelector((state) => state.Workflow);
  const file = useSelector((state) => state.FileInfo);
  const fileUMet = useSelector((state) => state.File);
  const calculateData = useSelector(state => state.CalculateDataFile)

  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(fileActions.GetFileInfo(location.state.folioId))
    dispatch(creditActions.GetCalculateDataFile(location.state.folioId));
    setActiveFileInfo(true)
    console.log("location.state ", location.state)
    setTitle("Calculadora")
    setFileId(location.state.folioId)
    setActiveInitial(true)
    console.log("location.selectEdit: ", location.state.selectEdit)
  }, []);

  useEffect(() => {
    setLoadView(file.loading)
    console.log("....................file:---- ", file)
    console.log("....................calculateData.itemsFormat:---- ", calculateData.itemsFormat)
    if (file.items != undefined && calculateData.itemsFormat != undefined && activeFileInfo) {
      setStageProps(file.items?.Stage)

      // Configuracion Slider de properties
      let optionsValues = file.items.Stage.Properties.find(item => item.Name == "CalculatorOptions")
      let optionsArray = JSON.parse(optionsValues.Value);
      // console.log("optionsArray: ", optionsArray)
      let orderArray = optionsArray.sort((a, b) => a.Plazo - b.Plazo)
      // console.log("orderArray: ", orderArray)
      let arregloDefault = orderArray[0];
      // console.log("arregloDefault: ", arregloDefault)
      let objVale = {
        index: 0,
        Name: arregloDefault.Name,
        TasaAnual: arregloDefault.TasaAnual,
        TasaMensual: arregloDefault.TasaMensual,
        CAT: arregloDefault.CAT,
        Plazo: plazoCurrent
      }

      setPlazo(`${plazoCurrent} ${namePlazo}`)
      // setCalculatorOptions(itemsToList[0])
      setItemMonth(objVale)

      // console.log("Incio de calculos: monto ", montoCurrent, " - objVale: ", objVale)

      if (location.state?.selectEdit != undefined && location.state?.selectEdit != null) {
        console.log("location.state.selectEdit.plazo:---- ", location.state.selectEdit.plazo)
        operationsCalculate(objVale, location.state.selectEdit.plazo)
      } else {
        operationsCalculate(objVale, montoCurrent)
      }
    }
  }, [file, calculateData])

  useEffect(() => {
    console.log("................calculateData******************: ", calculateData)
    if (calculateData.items != undefined && calculateData.itemsFormat != undefined) {
      console.log("calculateData******************: ", calculateData)
      setMaxSlider(calculateData.itemsFormat?.LimiteSuperior)
      setMaxAmount(`${calculateData.itemsFormat?.LimiteSuperior}`)
      setCapacidadPago(calculateData.itemsFormat?.CapacidadPago)
      setSaltoSlaider(calculateData.itemsFormat?.Saltos)
      setMinSlider(calculateData.itemsFormat?.LimiteInferior)
      setNamePlazo(calculateData.itemsFormat?.PlazoNombre)
      setNamePlazoCalculate(calculateData.itemsFormat?.PlazoNombreCalculate)
      setOptionsPlazos(calculateData.itemsFormat?.PlazosList)
      setPlazoCurrent(calculateData.itemsFormat?.PlazosList[0]?.value)
      setMontoCurrent(calculateData.itemsFormat?.LimiteInferior)
    }
  }, [calculateData])

  
  useEffect(() => {
    console.log("eventChange*****: ", watchMonto)
    if (watchMonto > maxSlider) {
      Alert({
        icon: "error",
        text: "El monto ingresado es mayor al permitido, por favor ingresa un monto menor para continuar.",
        okbtntext: t("general_accept"),
      });
      setValue("txtMonto",minSlider)
      operationsCalculate(itemMonth, minSlider)
    } else if (watchMonto < 0) {
      setValue("txtMonto",minSlider)
      Alert({
        icon: "error",
        text: "El monto ingresado es menor al permitido, por favor ingresa un monto mayor para continuar.",
        okbtntext: t("general_accept"),
      });
      operationsCalculate(itemMonth, minSlider)
    } else {
      setValue("txtMonto",watchMonto === '' ? 0 : Number(watchMonto))
      operationsCalculate(itemMonth, watchMonto)
    }
  }, [watchMonto]);

  let operationsCalculate = (itemValue, valueAmount, plazoValue = plazoCurrent) => {
    if (itemValue.TasaAnual === undefined || itemValue.TasaAnual === null || itemValue.TasaAnual == "") {
      return;
    }
    let iva = 1.16
    // Tasa Anual
    setTasaAnual(`${itemValue.TasaAnual.toFixed(2)}%`)
    // Tasa Anual con IVA
    let tasaAnualIva = itemValue.TasaAnual * iva
    setTasaAnualIva(`${tasaAnualIva.toFixed(2)}%`)
    // Tasa Mensual
    setTasaMensual(`${itemValue.TasaMensual.toFixed(2)}%`)
    // Tasa Mensual con IVA
    let tasaMensualIva = itemValue.TasaMensual * iva
    setTasaMensualIva(`${tasaMensualIva.toFixed(2)}%`)
    // CAT
    setCat(`${itemValue.CAT}%`)
    // Pago mensual
    let rawAmount = valueAmount
    console.log("plazoCurrent: monto value, calculate", plazoValue)
    let termRaw = (plazoValue === undefined ? 18 : plazoValue)
    let annualRateRaw = itemValue.TasaAnual
    let annualRateWhitIVA = tasaAnualIva
    let monthlyInterest = (annualRateWhitIVA / (12 * 100))
    let monthlyPayment = rawAmount * monthlyInterest / (1 - Math.pow(1 + monthlyInterest, (termRaw * -1))) - 0.242

    // console.log("monthlyPayment: monto value", monthlyPayment)
    setPagoMensual(monthlyPayment.toFixed(2))
    if (capacidadPago <= 0) {
      setActiveButton(true)
    } else if (monthlyPayment < capacidadPago) {
      setActiveButton(true)
    } else {
      setActiveButton(false)
    }

    // console.log("toFixed ", monthlyPayment.toFixed(2))
    // Se guardan los item
    let objVale = {
      Name: itemValue.Name,
      TasaAnual: itemValue.TasaAnual,
      TasaMensual: itemValue.TasaMensual,
      CAT: itemValue.CAT,
      PagoMensual: monthlyPayment,
      IsCalculator: "true",
      Monto: valueAmount,
      Plazo: plazoValue,
    }
    setItemMonth(objVale)
  }

  let removeAmount = () => {
    // console.log("Valor add - : ", value)
    if (montoCurrent != 1000) {
      if (montoCurrent > 999) {
        // console.log("Remove value: ", value)
        setMontoCurrent(montoCurrent - saltoSlaider)
        operationsCalculate(itemMonth, montoCurrent - saltoSlaider)
      }
    }
  }

  // Agregar monto (saltos de mil)
  let addAmount = () => {
    console.log("Valor add + : ", montoCurrent, "itemMonth: ", itemMonth)
    // if (value != 100000) {
    if (maxSlider > montoCurrent) {
      setMontoCurrent(montoCurrent + saltoSlaider)
      operationsCalculate(itemMonth, montoCurrent + saltoSlaider)
    }
    // }
  }

  const handleSliderChange = (event, newValue) => {
    // console.log("handleSliderChange: newValue ", newValue)
    setMontoCurrent(newValue);
    operationsCalculate(itemMonth, newValue)
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  let handleBackCalculator = (e) => {
    let nextStage = file.items.Stage
    let stageName = nextStage.Name
    let stageId = nextStage.Id
    let folioId = fileId
    let stage = file.items.Stage

    let nextComponent = "CreditSelectionComponent"
    coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })
  }

  let handleCredithOffer = (e) => {
    let nextStage = file.items.Stage
    let stageName = nextStage.Name
    let stageId = nextStage.Id
    let folioId = fileId
    let stage = file.items.Stage
    let items = itemMonth
    let plazoType = namePlazo

    let nextComponent = "CreditOfferComponent"
    coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId, items, plazoType } })
  }

  let handleCmbPlazoSelect = (event) => {
    console.log("handleCmbPlazoSelect ---: ", event.target)
    setPlazoCurrent(event.target.value)
    setPlazo(`${event.target.value} ${namePlazo}`)

    operationsCalculate(itemMonth, montoCurrent, event.target.value)
    // console.log("namePlazo*****", namePlazo, namePlazo == "meses")
    // let ListOptions = dependencData.formatData?.find(item => item.Value === dependenceCurrent)
    // let valuesOptionsPos = ListOptions.PlazoNombre == "meses" ? formatPlazoMeses(event.target.value) : formatPlazoMeses(convertQuincenaMes(event.target.value))
    // console.log("Quincenas a mes: valuesOptionsPos*******: ", valuesOptionsPos)
    // LlenadoInformacion(ListOptions, itemsMonth, valuesOptionsPos)
  };

  return (<GenericContainer>
    <FormProvider {...formMethods} theme={theme}>
      <Typography variant="h6" gutterBottom>
        {title}
        <HelpRounded
          className={localStyles.helpIcon}
          onClick={handleClickOpen}
        />
      </Typography>
      <Typography variant="h6" gutterBottom sx={{ marginTop: '0px', textAlign: 'center' }} >{capacidadPago > 0 ? "Monto de crédito" : "Capacidad de pago"}</Typography>
      <Grid container spacing={1} justifyContent="center" >
        <Grid item xs={1.5} sm={1} justifyContent="center" alignItems="center">
          <IconButton
            color="primary"
            aria-label="remove"
            component="span"
            onClick={removeAmount}>
            <RemoveCircle />
          </IconButton>
        </Grid>
        <Grid item xs={9} sm={10} justifyContent="center" alignItems="center" >
          <InputField
            inputType="currency"
            control={control}
            register={register}
            name='txtMonto'
            validations={{ required: true }}
            required={true}
            defaultValue={capacidadPago ?? 0}
            error={!!formState.errors['txtMonto']}
            helperText={formState.errors['txtMonto']?.message}
          />
        </Grid>
        <Grid item xs={1.5} sm={1} justifyContent="center" alignItems="center">
          <IconButton
            color="primary"
            aria-label="add"
            component="span"
            onClick={addAmount}>
            <AddCircle />
          </IconButton>
        </Grid>
        <Grid item xs={12} sm={12} justifyContent="center" alignItems="center">
          <Slider sx={(theme) => ({
            marginLeft: '1em', marginRight: '1em', padding: '10px 0 0 0 !important',
            [theme.breakpoints.only('xs')]: {
              width: '93%'
            },
          })}
            value={typeof value === 'number' ? montoCurrent : 0}
            aria-label="custom thumb label"
            color="primary"
            step={saltoSlaider}
            min={minSlider}
            max={maxSlider}
            onChange={handleSliderChange} />
        </Grid>
        <Grid item xs={2} sm={2} justifyContent="center" alignItems="center">
          {`${formatterDolar.format(minSlider)}`}
        </Grid>
        <Grid item xs={8} sm={8} justifyContent="center" alignItems="center" >

        </Grid>
        <Grid item xs={2} sm={2} justifyContent="center" alignItems="center" sx={{ textAlign: 'end' }}>
          {`${formatterDolar.format(maxAmount)}`}
        </Grid>
      </Grid>

      <Typography variant="h6" gutterBottom sx={{ marginTop: '5px', textAlign: 'center' }}>Plazo</Typography>
      <InputField
        inputType="select"
        register={register}
        name="cmbPlazos"
        optionsList={optionsPlazos}
        validations={{ required: true }}
        error={!!formState.errors["cmbPlazos"]}
        helperText={formState.errors["cmbPlazos"]?.message}
        required={true}
        placeholder="Plazos"
        value={plazoCurrent}
      />

      <Typography variant="h6" gutterBottom sx={{ marginTop: '5px', textAlign: 'center' }}>{`Pago ${namePlazoCalculate}`}</Typography>
      <Typography variant="subtitle1" gutterBottom sx={{ textAlign: 'center' }}>{formatterDolar.format(pagoMensual)}</Typography>
      <Grid container spacing={1} justifyContent="center" >
        <Grid item xs={8} sm={8}  >
          <Typography
            variant="subtitle1"
            gutterBottom
            className={localStyles.calculatesText}>{"Tasa anual"}</Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            className={localStyles.calculatesText}>{"Tasa anual con IVA"}</Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            className={localStyles.calculatesText}>{"Tasa mensual"}</Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            className={localStyles.calculatesText}>{"Tasa mensual con IVA"}</Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            className={localStyles.calculatesText}>{"CAT"}</Typography>
        </Grid>
        <Grid item xs={4} sm={4} >
        <Typography
            variant="subtitle1"
            gutterBottom
            className={localStyles.calculatesText}>{tasaAnual}</Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            className={localStyles.calculatesText}>{tasaAnualIva}</Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            className={localStyles.calculatesText}>{tasaMensual}</Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            className={localStyles.calculatesText}>{tasaMensualIva}</Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            className={localStyles.calculatesText}>{cat}</Typography>
        </Grid>
      </Grid>
      <Buttons marginTop={0} ConfirmButtonText="Solicitar crédito"
        onClickConfirm={handleCredithOffer}
        CancelButtonText="Explorar ofertas"
        onClickCancel={handleBackCalculator} />

      {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}
      <GenericDialog open={open}
        onClose={handleClose}
        title="¿Cómo se calculan las comisiones?"
        content={<Box sx={{
          display: 'flex',
          position: 'relative',
          height: '80vh',
          flexDirection: "column",
        }}>
          <Typography variant="h6" gutterBottom  >Tasa anual.</Typography>
          <Typography variant="subtitle1" gutterBottom >{Parser("Es la tasa que se cobra por los préstamos o las ganancias obtenidas a través de una inversión, y se expresa como un porcentaje que representa el costo anual real de los fondos durante el plazo de un préstamo. <br> Esto incluye cualquier cargo o costo adicional asociado con la transacción pero no toma en cuenta la capitalización.")}</Typography>
          <Typography variant="subtitle1" gutterBottom >¿Cómo se calcula la Tasa Anual de un préstamo?</Typography>
          <Typography variant="subtitle1" gutterBottom >{Parser("Para calcular la tasa efectiva anual de un préstamo es necesario conocer el valor neto del préstamo solicitado, la tasa de interés establecida por la entidad financiera o prestamista y el plazo en que el mismo debe ser cancelado <br> Una vez determinadas estas tres variables, se utiliza una fórmula para determinar el valor de cada cuota mensual. <br> Sería: EAR = 1 + inn –1EAR = Tasa de interés efectiva anuali = Tasa de interés nominaln = cantidad de pagos consecutivos cancelados en un añoPasos para calcular la tasa efectiva anual de un préstamo.")}</Typography>
          <Typography variant="subtitle1" gutterBottom >1.En primer lugar se divide la tasa de interés nominal entre 100 para convertirlo en número natural.</Typography>
          <Typography variant="subtitle1" gutterBottom >2.Entonces se divide el resultado entre la cantidad de pagos a realizar en el año, es decir, si es pago mensual seríandividido entre 12, si es pago semestral sería dividido entre 2, etc.</Typography>
          <Typography variant="subtitle1" gutterBottom >3.Se le suma una unidad al resultado (+1)</Typography>
          <Typography variant="subtitle1" gutterBottom >4.El resultado se eleva a la potencia de n (pagos a realizar anualmente).</Typography>
          <Typography variant="subtitle1" gutterBottom >{Parser("5. Por último se resta una unidad (-1) y este será el valor de latasa efectiva de interés anual de un préstamo.<br>Ejemplo:<br> 1.Tenemos una tasa de interés nominal del 15% (15/100 = 0,15), cuyo préstamo debe ser pagado en cuotas trimestrales.")}</Typography>
          <Typography variant="subtitle1" gutterBottom >2.EAR = 0,15/4 (número de trimestres en el año) = 0,0375 + 1 = 1,03753. EAR = 1,0375^4 = 1,1586 –1 = 0,1586</Typography>
        </Box>}
      />
    </FormProvider >
  </GenericContainer>);
}
